import { Validators } from "@angular/forms";
import { Component, OnInit, OnDestroy, ViewChild, Inject } from "@angular/core";
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";
import { ManageService } from "../../../services/manage.service";
import { CommonService } from "../../../services";
import { ActivatedRoute, Router } from "@angular/router";
import { ADKDetailsViewModel } from "../../../models/adk-details-view.model";
import { ApiResponse } from "../../../models/api-response.model";
import { Subject } from "rxjs";
import { CheckOutService } from "../../../services/checkout.service";
import { DickerSelectListItem } from "../../../models/csp.model";
import { SuburbList } from "../../../models/account-delivery-address";
import {
  CurrentUserModel,
} from "../../../models/account-ledger.model";
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";
import { DOCUMENT } from "@angular/common";
import { AuthService } from "../../../services/auth.service";
import { Observable, combineLatest, of } from "rxjs";
import { merge, switchMap, takeUntil, tap } from "rxjs/operators";
import { DDCustomer } from "../../../models/customer.model";
import { CustomerService } from "../../../services/customer.service";

@Component({
  selector: "app-edit-payment-detail",
  templateUrl: "./edit-payment-detail.component.html",
  styleUrls: ["./edit-payment-detail.component.css"],
})
export class EditPaymentDetailComponent implements OnInit, OnDestroy {
  userFormGroup: FormGroup;
  tenantId: string;
  programType: string = "CSP";
  companyCode: string = "";
  details: ADKDetailsViewModel;
  setFullWindow: boolean = true;
  title: string = "Edit Payment Details";
  loadContent: boolean = false;
  tenantUpdated: boolean = true;
  filterInput: string;
  hasEmptyFilterResult: boolean = false;
  filterResultArr: any;
  paymentList: DickerSelectListItem[] = [];
  selectedPayment: string = "";
  ngUnsubscribe: Subject<void> = new Subject<void>();
  filteredPostCode: SuburbList[];
  filteredSub: SuburbList[];
  editable = false;
  canCreateDigitalWallet: boolean = true;

  // validationArray: any[] = [
  //   {
  //     field: "out_company_name",
  //     class: "editTenantNameValidate",
  //     message: "Please enter tenant name",
  //   },
  //   {
  //     field: "out_tenant_desc",
  //     class: "editTenantDescriptionValidate",
  //     message: "Please enter tenant description",
  //   },
  //   {
  //     field: "out_first_name",
  //     class: "editTenantFirstNameValidate",
  //     message: "Please enter first name",
  //   },
  //   {
  //     field: "out_last_name",
  //     class: "editTenantLastNameValidate",
  //     message: "Please enter last name",
  //   },
  //   {
  //     field: "out_email",
  //     class: "editTenantEmailValidate",
  //     message: "Please enter tenant email",
  //   },
  //   {
  //     field: "out_address_1",
  //     class: "editTenantAddressLine1Validate",
  //     message: "Please enter address",
  //   },
  //   {
  //     field: "out_city",
  //     class: "editTenantCityValidate",
  //     message: "Please enter suburb",
  //   },
  //   {
  //     field: "out_region",
  //     class: "editTenantStateValidate",
  //     message: "Please enter state",
  //   },
  //   {
  //     field: "out_post_code",
  //     class: "editTenantPostCodeValidate",
  //     message: "Please enter postcode",
  //   },
  //   {
  //     field: "out_phone",
  //     class: "editTenantPhoneNumberValidate",
  //     message: "Please enter phone number",
  //   },
  // ];
  validationArray: any[] = [
    {
      field: "out_min_threshold",
      class: "editTenantMinThresholdValidate",
      message: "Please enter warning alert limit",
    },
    {
      field: "out_max_threshold",
      class: "editTenantMaxThresholdValidate",
      message: "Please enter critical alert limit",
    },
    {
      field: "out_threshold_email",
      class: "editTenantThresholdEmailValidate",
      message: "Please enter notification email",
    }
  ];
  @ViewChild("myAutocompleteTriggerSub")
  private _myAutocompleteTriggerSub: MatAutocompleteTrigger;
  @ViewChild("myAutocompleteTriggerPostcode")
  private _myAutocompleteTriggerPostcode: MatAutocompleteTrigger;

  public currentUserModel: CurrentUserModel;

  constructor(
    private manageService: ManageService,
    private customerService: CustomerService,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private checkOutService: CheckOutService,
    private router: Router,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    @Inject(DOCUMENT) private _document: Document
  ) {
    this.userFormGroup = this.formBuilder.group({
      out_tenant_id: new FormControl({ value: "", disabled: true }),
      out_company_name: new FormControl({ value: "" }, Validators.required),
      out_tenant_desc: new FormControl("", Validators.required),
      out_first_name: new FormControl("", Validators.required),
      out_last_name: new FormControl("", Validators.required),
      out_email: new FormControl( "", this.commonService.emailValidatorRegex()),
      out_address_1: new FormControl(""),
      out_address_2: new FormControl(""),
      out_address_3: new FormControl(""),
      out_city: new FormControl("", Validators.required),
      out_region: new FormControl("", Validators.required),
      out_post_code: new FormControl("", [
        Validators.required,
        Validators.maxLength(4),
      ]),
      out_phone: new FormControl("", Validators.required),
      out_customer_id: new FormControl(""),
      out_country: new FormControl(""),
      out_culture: new FormControl(""),
      out_digital_wallet_id: new FormControl(""),
      out_min_threshold: new FormControl(""),
      out_max_threshold: new FormControl(""),
      out_threshold_email: new FormControl(""),
    });
    this.userFormGroup.disable();
  }

  ngOnInit() {
    this.companyCode = this.commonService.readCookie("CompanyCode");

    $("#levelOne").animate({ scrollLeft: $("#managecsp").width() + 505 }, 400);

    this.activatedRoute.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params) => {
      this.tenantId = params.get("tenantId");
    });

    const csp$: Observable<ADKDetailsViewModel> = this.manageService.currentDetailsWatch;

    const user$: Observable<CurrentUserModel> = this.authService.getLoginInfo();

    const update$ = this.manageService.updateDigiwalWalletSubject.asObservable().pipe(switchMap(() => customerPayments$));

    const customerPayments$: Observable<DickerSelectListItem[]> = user$.pipe(
      tap((user: CurrentUserModel) => {
        this.currentUserModel = user;
        if (user.hasAdminAccess === false && user.hasPurchaseAccess === false) {
          this.canCreateDigitalWallet = false;
        }
      }),
      switchMap((user: CurrentUserModel) => {
        if (user.hasAdminAccess) {
          return this.checkOutService.GetSubscriptionDigitalWallet();
        } else if (user.hasPurchaseAccess) {
          return this.checkOutService.GetSubscriptionDigitalWallet(user.loginId);
        } else {
          return of([]);
        }
      })
    );


    const merge$ = update$.pipe(merge(customerPayments$));

    combineLatest([csp$, merge$]).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      ([csp, customerPayments]) => {

        this.paymentList = customerPayments;

        this.selectedPayment = "";

        if (csp.customer.out_digital_wallet_id) {

          const selectedPayment = customerPayments.find(m => m.value === csp.customer.out_digital_wallet_id);

          if (selectedPayment) {

            this.selectedPayment = selectedPayment.value;

            // this.editable = true;

            // this.userFormGroup.enable();
          }
          this.editable = true;

          this.userFormGroup.enable();

        } else {

          this.editable = true;

          this.userFormGroup.enable();
        }

        this.loadContent = true;
      }
    )

    csp$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((csp: ADKDetailsViewModel) => {
      this.userFormGroup.get("out_tenant_id").setValue(this.tenantId);
     if (csp && !this.commonService.isEmpty(csp)){


      this.userFormGroup
        .get("out_company_name")
        .setValue(csp.customer.out_company_name);
      this.userFormGroup
        .get("out_tenant_desc")
        .setValue(csp.customer.out_tenant_desc);
      this.userFormGroup
        .get("out_first_name")
        .setValue(csp.customer.out_first_name);
      this.userFormGroup
        .get("out_last_name")
        .setValue(csp.customer.out_last_name);
      this.userFormGroup
        .get("out_email")
        .setValue(csp.customer.out_email);
      this.userFormGroup
        .get("out_address_1")
        .setValue(csp.customer.out_address_1);
      this.userFormGroup
        .get("out_address_2")
        .setValue(csp.customer.out_address_2);
      this.userFormGroup
        .get("out_address_3")
        .setValue(csp.customer.out_address_3);
      this.userFormGroup.get("out_city").setValue(csp.customer.out_city);
      this.userFormGroup
        .get("out_region")
        .setValue(csp.customer.out_region);
      this.userFormGroup
        .get("out_post_code")
        .setValue(csp.customer.out_post_code);
      this.userFormGroup
        .get("out_phone")
        .setValue(csp.customer.out_phone);
      this.userFormGroup
        .get("out_min_threshold")
        .setValue(csp.customer.out_min_threshold);
      this.userFormGroup
        .get("out_max_threshold")
        .setValue(csp.customer.out_max_threshold);
      this.userFormGroup
        .get("out_threshold_email")
        .setValue(csp.customer.out_threshold_email);
      this.userFormGroup
        .get("out_customer_id")
        .setValue(csp.customer.out_customer_id);
      this.userFormGroup
        .get("out_country")
        .setValue(csp.customer.out_country);
      this.userFormGroup
        .get("out_culture")
        .setValue(csp.customer.out_culture);
      this.userFormGroup
        .get("out_digital_wallet_id")
        .setValue(csp.customer.out_digital_wallet_id);
     }
    });

  }

  updateEndUser(): void {

    if (this.userFormGroup.valid) {
      this.loadContent = false;
      this.manageService
        .UpdateTenantInfo(this.userFormGroup.getRawValue())
        .subscribe(
          (res: ApiResponse) => {
            if (res && res.status) {
              this.commonService.implementToast(res.responseMessage, "Success");
              this.manageService.getOrRefreshSubscriptionOrderSubject.next(true);

            } else {

              this.commonService.implementToast(res.responseMessage, "Error");
            }
            this.loadContent = true;
          },
          (error: any) => {
            console.info(error);
            this.loadContent = true;
          }
        );
      // ?
    } else {
      this.validationArray.forEach((item) => {
        this.validateFields(item);
      });
    }
  }

  validateFields(item: any) {
    if (item.field === "out_email") {
      if (this.userFormGroup.get(item.field).hasError("required")) {
        this.commonService.showValidator(
          "." + item.class,
          item.message,
          "right",
          "error"
        );
      } else if (this.userFormGroup.get(item.field).hasError("email")) {
        this.commonService.showValidator(
          "." + item.class,
          "Please enter a valid email address",
          "right",
          "error"
        );
      }
    } else {
      if (!this.userFormGroup.get(item.field).valid) {
        this.commonService.showValidator(
          "." + item.class,
          item.message,
          "right",
          "error"
        );
      }
    }
  }

  selectPaymentMethod() {
    this.checkOutService
      .UpdateEBillingCustomerNo(
        this.selectedPayment,
        this.tenantId,
        this.programType
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: ApiResponse) => {
        if (value.status === true) {
          this.manageService.getOrRefreshSubscriptionOrderSubject.next(true);
          this.commonService.implementToast(value.responseMessage, "Success");
        } else {
          this.commonService.implementToast(value.responseMessage, "Error");
        }
      });
  }

  resetPayment() {
    this.selectedPayment = "";
    this.selectPaymentMethod();
  }

  navigateToDigitalWallet() {
    this.router.navigate(["CreateDigitalWallet"], { relativeTo: this.activatedRoute });
    //this.router.navigateByUrl("/myAccount/digitalwallet?createNew=true");
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    this.manageService.monitorSelectedTabIndex(0);
    if (this.isInCustiomerMenu()) {
      this.customerService.currentCustomerWatch.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: DDCustomer) => { 
        this.router.navigateByUrl("/customers/" + res?.id  + "/CSP/" + this.tenantId);
      });
    } else {
      this.router.navigateByUrl(
        "/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/" + this.tenantId
      );
    }
  }

  private isInCustiomerMenu(): boolean {
    return this.router.url.includes('customer');
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
